import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from '../form/View'
import Header from '../form/Header'
import Footer from '../form/Footer'

const useStyles = createUseStyles(theme => {
  return ({
    root: {
      height: '100%',
      flexDirection: 'column',
      flex: 1
    },
    content: {
      flex: 1,
      flexGrow: 1,
      overflowY: 'auto',
      margin: '0 36px',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    documentTitle: {
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: 'bold',
      color: '#454545',
      fontSize: '36px',
      '@media(max-height: 976px)': {
        fontSize: '28px',
      },
    },
    documentContent: {
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '32px',
      '@media(max-height: 976px)': {
        fontSize: '18px',
      },
    }
  });
})

function CameraViewError (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })

  return (
    <View className={styles.root}>
      <Header 
        title={"Erro ao abrir a câmera :("}
        index={props.index} 
        numOfSteps={props.numOfSteps}
        showMarkers={true}
      />

      <View className={styles.content}>
        <p className={styles.documentContent}>Um problema foi encontrado ao tentar abrir sua camera.</p>
        <p className={styles.documentTitle}>Instruções</p>
        <p className={styles.documentContent}>1. Verifique as permissões do navegador</p>
        <p className={styles.documentContent}>2. Tente refazer o processo em outro navegador</p>
      </View>

      <Footer 
        onBack={() => props.onCancel()}
        onNext={() => props.onNext(null)}
        nextLabel={'Continuar sem foto'}
      />
    </View>
  )
}

export default CameraViewError